import type { ResponseRead } from "epsm-api-types";
import { Converter } from "epsm-api-types/converter";
import { BaseService } from "@/services/BaseService";
import { HttpClient, type IHttpClient } from "@/services/HttpClient";
import type { Tabs } from "./types";

export class TabsStateService extends BaseService<Tabs, Tabs> {
	private constructor(private httpClient: IHttpClient) {
		super(new Converter());
	}
	private static instance: TabsStateService;

	static create() {
		if (!TabsStateService.instance) {
			TabsStateService.instance = new TabsStateService(HttpClient.create());
		}
		return TabsStateService.instance;
	}

	async getData(userId: string): Promise<ResponseRead<Tabs>> {
		try {
			const response = await this.httpClient.get<ResponseRead<Tabs>>(
				`tabs/state/${userId}`,
			);
			return this.getResponseItem(response);
		} catch (_e) {
			return {};
		}
	}

	async setData(userId: string, data: Tabs) {
		await this.httpClient.put<Tabs>(`tabs/state/${userId}`, {
			data,
		});
	}

	async removeData(userId: string) {
		await this.httpClient.delete<ResponseRead<Tabs>>(`tabs/state/${userId}`);
	}
}
